const { Button } = require('primereact/button');

export const FormFooter = ({ onSubmit }) => (
  <div className="footer-btn w-100">
    <Button type="submit" label="Save" className="p-button p-component p-button p-button-secondary" onClick={onSubmit} />
  </div>
);
